module.exports = __webpack_public_path__ + "static/img/contract_temp.1f55a9c0.png";